import { snackbar } from "@bcmi-labs/art-ui/components"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_authlayout/_none/registration/")({
  loader: ({ preload }) => {
    // This route does not exist anymore. Redirect to courses and emit a snackbar message
    if (!preload) {
      snackbar({
        message: "Kit registration is no longer necessary. You can access your courses directly.",
        variant: "info"
      })
      redirect({ to: "/courses", throw: true })
    }
  },
  head: () => ({
    meta: [
      {
        title: "Kit Registration | Arduino Cloud"
      }
    ]
  })
})
